import { render, staticRenderFns } from "./movie-list.vue?vue&type=template&id=6a96800f&scoped=true&"
import script from "./movie-list.vue?vue&type=script&lang=js&"
export * from "./movie-list.vue?vue&type=script&lang=js&"
import style0 from "./movie-list.vue?vue&type=style&index=0&id=6a96800f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96800f",
  null
  
)

export default component.exports